import { getRuntimeEnv } from '@components/env/extractEnvFromScript'

const assetLoader = () => {
  let ACKO_ENV = process.env.ACKO_ENV
  if (typeof window !== 'undefined') {
    ACKO_ENV = getRuntimeEnv()?.ACKO_ENV
  }
  let endpoint
  if (ACKO_ENV === 'master') {
    endpoint = 'https://acko-seo-assets.ackoassets.com/_next_static'
  } else if (ACKO_ENV === 'prod' || ACKO_ENV === 'pre-prod') {
    endpoint = 'https://acko-seo-prod-assets.ackoassets.com/_next_static'
  } else {
    endpoint = 'https://carbon.ackodev.com'
  }
  return endpoint
}

export const cmsLoader = ({ src }) => src

export default assetLoader
